import { EngineType } from '@/services/room.service';

export const ENGINE_OPTIONS = [
  { label: "Twilio", value: EngineType.TWILIO },
  { label: "Whereby", value: EngineType.WHEREBY },
  { label: "Vicollo", value: EngineType.VICOLLO },
  { label: "Tokbox", value: EngineType.TOKBOX, disabled: true },
  { label: "Zoom", value: EngineType.ZOOM, disabled: true },
];
